// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Context from "../../provider/Context.bs.js";
import * as Atom_Cta from "../atom/Atom_Cta.bs.js";
import * as Atom_Row from "../atom/Atom_Row.bs.js";
import * as Atom_Cell from "../atom/Atom_Cell.bs.js";
import * as Atom_Text from "../atom/Atom_Text.bs.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Atom_Text_Ds from "../atom/Atom_Text_Ds.bs.js";
import * as Binding_Date from "../../binding/Binding_Date.bs.js";
import * as Particle_Screen_Ds from "../particle/Particle_Screen_Ds.bs.js";
import * as Particle_Spacer_Ds from "../particle/Particle_Spacer_Ds.bs.js";
import * as Particle_Accessibility from "../particle/Particle_Accessibility.bs.js";
import * as Particle_Screen_Constants from "../particle/Particle_Screen_Constants.bs.js";

var rules = Particle_Screen_Ds.make(undefined, undefined, [CssJs.minWidth({
            NAME: "px",
            VAL: 110
          })], [CssJs.minWidth({
            NAME: "px",
            VAL: 180
          })], undefined, [CssJs.minWidth({
            NAME: "px",
            VAL: 100
          })]);

function Molecule_Select_Days_Presse$SelectItem(Props) {
  var date = Props.date;
  var status = Props.status;
  var ariaLabel = Props.ariaLabel;
  var onClick = Props.onClick;
  var match = Context.I18n.getState(undefined);
  var dateWithFormat = match.formaters.dateWithFormat;
  var ctaRef = React.useRef(null);
  var ctaAccessibility = ariaLabel !== undefined ? Particle_Accessibility.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, ariaLabel, undefined, undefined, undefined, undefined, undefined, undefined, undefined) : undefined;
  var tmp = {
    children: null,
    ctaRef: ctaRef,
    direction: Particle_Screen_Constants.flexDirectionColumn,
    onClick: (function (param) {
        Curry._1(onClick, date);
      }),
    style: {
      TAG: /* Presse */16,
      _0: {
        TAG: /* SelectDay */5,
        _0: status
      }
    }
  };
  if (ctaAccessibility !== undefined) {
    tmp.accessibility = Caml_option.valFromOption(ctaAccessibility);
  }
  return React.createElement(Atom_Cell.make, {
              children: React.createElement(Atom_Cta.Button.Block.make, tmp, React.createElement(Atom_Text.make, {
                        children: Curry._2(dateWithFormat, date, Binding_Date.Format.fullWeekDay),
                        style: Atom_Text_Ds.Presse.makeDay(status)
                      }), React.createElement(Atom_Text.make, {
                        children: Curry._2(dateWithFormat, date, "dd. MMMM"),
                        style: Atom_Text_Ds.Presse.makeDate(status)
                      })),
              rules: rules
            });
}

var SelectItem = {
  rules: rules,
  make: Molecule_Select_Days_Presse$SelectItem
};

function makeArrowRules(direction, display) {
  var position = direction ? Particle_Screen_Ds.make(undefined, undefined, [CssJs.left({
                NAME: "px",
                VAL: 35
              })], [CssJs.left({
                NAME: "px",
                VAL: -13
              })], undefined, [
          CssJs.left({
                NAME: "px",
                VAL: 6
              }),
          CssJs.top({
                NAME: "px",
                VAL: 20
              })
        ]) : Particle_Screen_Ds.make(undefined, undefined, [CssJs.right({
                NAME: "px",
                VAL: 35
              })], [CssJs.right({
                NAME: "px",
                VAL: 0
              })], undefined, [
          CssJs.right({
                NAME: "px",
                VAL: 6
              }),
          CssJs.top({
                NAME: "px",
                VAL: 20
              })
        ]);
  var visibility = display ? CssJs.visibility("visible") : CssJs.visibility("hidden");
  return Particle_Screen_Ds.$$Array.concat(Particle_Screen_Ds.make(undefined, undefined, undefined, [
                  CssJs.position("absolute"),
                  visibility,
                  CssJs.top("auto")
                ], undefined, [
                  CssJs.position("absolute"),
                  visibility,
                  CssJs.top({
                        NAME: "px",
                        VAL: 5
                      })
                ]), position);
}

var justifyContent = Particle_Screen_Ds.make(undefined, undefined, "center", undefined, undefined, "start");

var blockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeVerticalAndHorizontal("XXS", "M", undefined)), undefined, Particle_Spacer_Ds.makeHorizontal("S"));

var rules$1 = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [
      CssJs.overflowX("hidden"),
      CssJs.unsafe("scroll-snap-align", "start"),
      CssJs.selector("::-webkit-scrollbar", [CssJs.display(CssJs.none)])
    ]);

function makeButtonDisplay(screen) {
  if (screen) {
    return Particle_Screen_Ds.make(undefined, undefined, undefined, "block", undefined, "none");
  } else {
    return Particle_Screen_Ds.make(undefined, undefined, undefined, "none", undefined, "block");
  }
}

function Molecule_Select_Days_Presse(Props) {
  var daysRange = Props.daysRange;
  var handleOnClick = Props.handleOnClick;
  var handleArrowClick = Props.handleArrowClick;
  var displayArrows = Props.displayArrows;
  var items = Belt_Array.map(daysRange, (function (item) {
          return React.createElement(Molecule_Select_Days_Presse$SelectItem, {
                      date: item.date,
                      status: item.status,
                      onClick: handleOnClick,
                      key: item.date.toDateString()
                    });
        }));
  return React.createElement(React.Fragment, undefined, React.createElement(Atom_Cta.Button.make, {
                  display: makeButtonDisplay(/* Mobile */0),
                  onClick: (function (param) {
                      Curry._1(handleArrowClick, /* Previous */1);
                    }),
                  style: {
                    TAG: /* Presse */16,
                    _0: /* NavPrev */9
                  },
                  rules: makeArrowRules(/* Previous */1, displayArrows.previous)
                }), React.createElement(Atom_Cta.Button.make, {
                  display: makeButtonDisplay(/* Mobile */0),
                  onClick: (function (param) {
                      Curry._1(handleArrowClick, /* Next */0);
                    }),
                  style: {
                    TAG: /* Presse */16,
                    _0: /* NavNext */10
                  },
                  rules: makeArrowRules(/* Next */0, displayArrows.next)
                }), React.createElement(Atom_Row.make, {
                  alignItems: Particle_Screen_Constants.alignItemsCenter,
                  blockSpace: blockSpace,
                  children: null,
                  justifyContent: justifyContent,
                  rules: rules$1,
                  width: Particle_Screen_Constants.oneHundredPctWidth,
                  wrap: /* OnOneLine */1
                }, React.createElement(Atom_Cta.Button.make, {
                      display: makeButtonDisplay(/* Desktop */1),
                      onClick: (function (param) {
                          Curry._1(handleArrowClick, /* Previous */1);
                        }),
                      style: {
                        TAG: /* Presse */16,
                        _0: /* NavPrev */9
                      },
                      rules: makeArrowRules(/* Previous */1, displayArrows.previous)
                    }), React.createElement(Atom_Cta.Button.make, {
                      display: makeButtonDisplay(/* Desktop */1),
                      onClick: (function (param) {
                          Curry._1(handleArrowClick, /* Next */0);
                        }),
                      style: {
                        TAG: /* Presse */16,
                        _0: /* NavNext */10
                      },
                      rules: makeArrowRules(/* Next */0, displayArrows.next)
                    }), items));
}

var make = Molecule_Select_Days_Presse;

export {
  SelectItem ,
  makeArrowRules ,
  justifyContent ,
  blockSpace ,
  rules$1 as rules,
  makeButtonDisplay ,
  make ,
}
/* rules Not a pure module */
